import { SortDirection } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/enums.pb';
import { getCampaignsSort, setCampaignsSort } from '@frontend/api-bulk-messaging';
import { FieldChangeEvent, useFormField } from '@frontend/design-system';

export const useSortDropdownField = () => {
  const sortDropdownFieldProps = useFormField({
    type: 'dropdown',
    value: getCampaignsSort(),
  });
  const modifiedSortDropdownFieldProps = {
    ...sortDropdownFieldProps,
    onChange: (e?: FieldChangeEvent) => {
      sortDropdownFieldProps.onChange(e);

      // @ts-expect-error TODO: Fix design system types. value does exist not exist on FieldChangeEvent in the design-system, but it should.
      setCampaignsSort(e?.value as SortDirection);
    },
  };
  const sortDirection = modifiedSortDropdownFieldProps.value as SortDirection;
  return { sortDropdownFieldProps: modifiedSortDropdownFieldProps, sortDirection };
};
